import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { useAddTeamMutation } from '../../store/team/TeamApi';
import { useNavigate, useParams } from 'react-router';
import { useFetchClubsQuery } from '../../store/club/ClubApi';
import SubTitle from '../club/SubTitle';
//import { TeamForm } from './TeamForm';
import { TeamWizard } from './TeamWizard';
import { TeamLabel } from '../../shares/Tools';
import { myConstants } from '../../shares/Constants';


export function TeamCreate()
{

  // aus den Parametern das aktuelle Jahr und das gewünschte Team ermitteln
  const {year, clubLabel, teamLabel, teamCounter } = useParams();
  const navigate = useNavigate();

  // Einlesen der Clubs zum aktuellen Turnierjahr
  const {data:clubs, isLoading:clubsAreLoading} = useFetchClubsQuery(year);
  // Heraussuchen des aktuellen Clubs
  const selectedClub = (clubs && !clubsAreLoading)?clubs?.filter( element => element.label === clubLabel)[0]:null;
  // Das Hinzufügen eines neuen Teams wird direkt hier durchgeführt
  const [addTeam, { isTeamLoading }] = useAddTeamMutation();



  // Starten der Sicherung des Teams
    const handleSubmit = async (formData) => {
    try {
      const newTeam = await addTeam({
        year,
        clubLabel,
        label: teamLabel,
        counter: parseInt(teamCounter),
        ...formData,
      }).unwrap();
      const isWaitlist = newTeam.status === myConstants.teamModel.status.waitlist;
      const snackBarMsg = isWaitlist
        ? `${TeamLabel(teamLabel, parseInt(teamCounter))} wurde auf die Arteliste gesetzt.`
        : `${TeamLabel(teamLabel, parseInt(teamCounter))} wurde erfolgreich angemeldet.`

      navigate(`/${year}/${clubLabel}/`, { state : { successMessage : snackBarMsg } });
    } catch (error) {
      console.error('Fehler beim Anmelden des Teams:', error);
    }
  };


  // Ausgaben der Einzeldaten pro Team mit den Möglichkeiten der Veränderung
  // einzelner Schritte. Dabei wollen wir aber sicherstellen, dass bestimmte
  // Anpassungen nach einem bestimmten Zeitpunkt nicht mehr verändert werden
  // können, sofern es sich denn nicht um Administratoren handelt.  (was aber noch eingestellt werden muss)

  // Die Funktion hier verwendet TeamForm als Komponente, da sowohl das Anlegen, als auch das bearbeiten hier
  // immer identisch sit. 
  return(
    <Box sx={{ flexGrow: 1 }} align="center">
      <SubTitle club={selectedClub} />
      <Box sx={{ maxWidth: 520 }}>
        <Typography variant="h4" sx={{mt:3}}>
          {teamLabel}{parseInt(teamCounter) > 1 ? ` ${teamCounter}` : ''}&nbsp;anmelden
        </Typography>
        <TeamWizard
          year={year}
          club={selectedClub}
          teamLabel={teamLabel}
          teamCounter={teamCounter}
          onSubmit={handleSubmit}
          isLoading={isTeamLoading}
        />
        {
          /*
            <TeamForm
              year={year}
              club={selectedClub}
              onSubmit={handleSubmit}
              isLoading={isTeamLoading}
              submitLabel="Team anmelden"
            />
          */
        }
      </Box>
    </Box>
  );
}